import { createFormContext } from "@mantine/form"
import type { Quiz } from "quiz/types/quiz.model"

export const [QuizFormProvider, useQuizFormContext, useQuizForm] =
  createFormContext<Omit<Quiz, "id">>()
